import { BookingAppReservationActionTypes } from "./types"
import type {
  BookingAppReservationState,
  BookingAppReservationAction,
} from "./types"
import { commonHelpers } from "@/utils/helpers"

export const initialState: BookingAppReservationState = {
  bookingAppReservations: [],
  bookingAppReservationsCount: 0,
  bookingAppReservationsError: "",
  bookingAppReservationsLoading: false,
}

const reducer = (state = initialState, action: BookingAppReservationAction) => {
  switch (action.type) {
    case BookingAppReservationActionTypes.FETCH_REQUESTED: {
      const { scope } = action.payload

      return {
        ...state,
        [`${scope}Loading`]: true,
        [`${scope}Error`]: "",
      }
    }
    case BookingAppReservationActionTypes.FETCH_SUCCEEDED: {
      const { scope, data, count } = action.payload

      return {
        ...state,
        [scope]: data,
        [`${scope}Loading`]: false,
        [`${scope}Error`]: "",
        ...(commonHelpers.isNumber(count)
          ? {
              [`${scope}Count`]: count,
            }
          : {}),
      }
    }
    case BookingAppReservationActionTypes.FETCH_FAILED: {
      const { scope, error } = action.payload

      return {
        ...state,
        [`${scope}Error`]: error,
      }
    }
    default: {
      return state
    }
  }
}

export default reducer
